module.exports = __webpack_public_path__ + "static/media/silence.1554b786.mp3";